export enum MAIN_TABS {
    Details,
    Tasks,
    Changes,
    Configuration
}

export enum EDIT_TYPE {
    Description = "description",
    Group = "group",
    Company = "company"
}

export enum CARDS {
    Accessories = "accessories",
    Can = "can",
    CanAdapter = "can_adapter",
    Carrier = "carrier",
    ConfigurationDetails = "configuration details",
    General = "general",
    Obd = "obd",
    Sim = "sim"
}

export enum CARD_ITEMS {
    AssignedPackage = "assigned package",
    BleDtb = "ble_dtb",
    BleFw = "ble_fw",
    BluetoothAuthorization = "bluetooth_authorization",
    BluetoothPassword = "bluetooth password",
    Bootloader = "bootloader",
    CanAdapterName = "can adapter name",
    CanBootstring = "can bootstring",
    CanOemFilePackage = "can oem file package",
    CanOemFileVehicle = "can oem file vehicle",
    CanProgramNumber = "program number",
    CanRevision = "revision",
    CanSoftwareDate = "software date",
    CarrierModuleId = "carrier module id",
    CarrierRevision = "carrier revision",
    CarrierSerialId = "carrier serial id",
    CarrierSettingsFilename = "carrier settings filename",
    CarrierUnitStatus = "carrier unit status",
    CarrierUnitType = "carrier unit type",
    Company = "company",
    Configuration = "configuration",
    Description = "description",
    Dtb = "dtb",
    Firmware = "firmware",
    GnssVersion = "gnss version",
    Group = "group",
    GsmNumber = "gsm number",
    Iccid = "iccid",
    Imsi = "imsi",
    Interface = "interface",
    MainConfiguration = "main configuration",
    ManualGeofenceScenarios = "manual_geofence_scenarios",
    ObdChipFirmwareVersion = "obd chip firmware version",
    OneWireAuthorization = "1_wire_authorization",
    ProductCode = "product code",
    Serial = "serial",
    Type = "type",
    Vin = "vin"
}
